export const Status = Object.freeze({
  All: 0,
  Delivered: 1,
  Processing: 2,
  Pickup: 3
});
